import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import Button from "../../../../common/element/Buttons";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ProviderRegisterPaymentInfo } from "../../../../actions/public/ProviderRegisterPaymentInfo";
import Card from "../../../../common/element/Card";
import Segment from "../../../../common/element/Segment";
import Dialog from "../../../../common/element/Dialog";
import { SignupProviderForYourself } from "../../../../actions/public/SignupProviderForYourself";
import { GetProviderInvoiceById } from "../../../../actions/public/GetProviderInvoiceById";
import moment from "moment";
import ThreeDotLoader from "../../../../common/element/ButtonLoader/ThreeDotLoader";
import {
  GettData,
  ResetData,
} from "../../../../redux/classes/common/ProviderRegisterData";
const RegistrationPaymentYourSelf = ({ formData, Setstep, EmptyData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [agree, setAgree] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [stripeBtn, setStripeBtn] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [dialogAddOpen, setDialogAddOpen] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsProcessing(true);
    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);
    const { error, token } = await stripe.createToken(cardElement);

    if (error) {
      setIsProcessing(false);
      setError(error.message);
      console.error(error);
    } else {
      let payload = {
        ...formData,
        payment_info: JSON.stringify({ ...paymentData, cardToken: token.id }),
        provider_type_id: paymentData?.provider_type_id,
      };
      if (paymentData?.provider_type_id || paymentData?.amount) {
        dispatch(SignupProviderForYourself(payload)).then((resp) => {
          if (resp.success) {
            dispatch(GetProviderInvoiceById({ sub_invoice_id: resp?.data?.sub_invoice_id })).then(
              (response) => {
                setIsProcessing(false);
                dispatch(ResetData());
                EmptyData()
                navigate("/provider-registration-invoice", {
                  state: {
                    data: {
                      ...response?.data,
                      amount: paymentData?.amount,
                      end_date: paymentData?.end_date,
                    },
                  },
                });
              }
            ).finally(() => {
              setIsProcessing(false);
            })

          } else {
            setIsProcessing(false);
          }
        });
      }
      else {
        setIsProcessing(false);
      }
    }
  };

  useEffect(() => {
    let payload = {
      registrationType: "forYourself",
      provider_type_id: formData?.provider_regist_data?.provider_type_id || "",
      invite_provider_id: "",
      isProviderExist: false,
      provider_org_id: "",
    };
    dispatch(ProviderRegisterPaymentInfo(payload)).then((response) => {
      if (response) {
        setPaymentData(response?.data);
      }
    });
  }, []);

  const onAddDialogClose = () => {
    EmptyData()
    setDialogAddOpen(false);
    dispatch(ResetData());
    navigate("/login");
  };

  return (
    <div
      style={{ backgroundColor: `#eff8ff` }}
      className="flex justify-between pr-6 pl-6"
    >
      <div className="w-full  justify-center flex flex-wrap">
        <form className="pb-20   pt-20">
          <div>
            <div className="w-full">
              <div className="inline-flex rounded-md mb-7 validation-filter">
                <div
                  style={{ backgroundColor: `#eff8ff` }}
                  className="flex justify-between pr-6 pl-6"
                >
                  <div className="w-full  justify-center flex flex-wrap">
                    <form className="pb-20   pt-20">
                      <Card className="registerBlock p-7 border border-gray-200 rounded-xl">
                        <h5 className="text-blue-800 font-semibold text-2xl mb-7">
                          Payment
                        </h5>
                        <h4 className="font-bold text-gray-700 text-base mb-1">
                          Annual License Fee
                        </h4>
                        <p className="text-gray-700 mb-7">
                          ${paymentData?.amount}
                        </p>
                        <h4 className="font-bold text-gray-700 text-base mb-1">
                          License Period
                        </h4>
                        <p className="text-gray-700">
                          {moment(new Date()).format("DD/MM/YYYY")} -{" "}
                          {moment(paymentData?.end_date).format("DD/MM/YYYY")}
                        </p>
                      </Card>
                      <div>
                        <div className="w-full">
                          <form>
                            <Card className="p-7 border border-gray-200 rounded-xl mt-7">
                              <h5 className="text-blue-800 font-semibold text-2xl mb-2">
                                Payment options
                              </h5>
                              {/* <div className="inline-flex rounded mb-3 validation-filter">
                                <Segment
                                  className="payment-btn"
                                  // onClick={preventDefault}
                                >
                                  <Segment.Item value="Stripe">
                                    <span onClick={() => setStripeBtn(true)}>
                                      <img
                                        src="/assets/icons-svg/stripe.svg"
                                        alt=""
                                      />{" "}
                                      Stripe
                                    </span>
                                  </Segment.Item>
                                </Segment>
                              </div> */}
                              <div className="bg-gray-100">
                                <div className="bg-white w-full">
                                  {/* Payment Method Buttons */}
                                  <h2 className="text-lg font-semibold mb-3">
                                    Card Information
                                  </h2>
                                  <form className="space-y-4">
                                    {/* Card Number */}
                                    <div className="border rounded-lg p-3 focus-within:border-blue-500 transition">
                                      <CardElement
                                        options={{
                                          hidePostalCode: true,
                                          disableAutofill: true, // Prevent autofill suggestions
                                          style: {
                                            base: {
                                              fontSize: "16px",
                                              color: "#333",
                                              "::placeholder": {
                                                color: "#a0aec0",
                                              },
                                            },
                                            invalid: { color: "#e53e3e" },
                                          },
                                        }}
                                      />
                                    </div>

                                    {/* Checkbox */}
                                    <div className="flex items-center gap-2">
                                      <input
                                        type="checkbox"
                                        id="terms"
                                        checked={agree}
                                        onChange={() => setAgree(!agree)}
                                        className="cursor-pointer"
                                      />
                                      <label
                                        htmlFor="terms"
                                        className="text-sm text-gray-600 cursor-pointer"
                                      >
                                        I understand and accept that this licensing fee is valid for 12 months
                                      </label>
                                    </div>

                                    {/* Submit Button */}

                                    {/* Error Message */}
                                    {error && (
                                      <p className="text-red-500 text-sm">
                                        {error}
                                      </p>
                                    )}
                                    <div className="flex mt-7 step2-btn-block form-footer justify-between">
                                      <BtnLight className="w-auto px-6 mr-2 flex justify-center items-center pre-step">
                                        <Button
                                          className=" px-6  flex justify-center items-center next-step"
                                          onClick={() => {
                                            Setstep(false);
                                          }}
                                        >
                                          <img
                                            src="assets/icons-svg/arrow-left.svg"
                                            alt=""
                                            className="mr-2"
                                          />{" "}
                                          Previous page
                                        </Button>
                                      </BtnLight>
                                      <BtnPrimary
                                        disabled={
                                           !agree ||
                                          isProcessing}
                                        className="w-auto px-6"
                                        onClick={handleSubmit}
                                      >
                                        {isProcessing ? (
                                          <ThreeDotLoader />
                                        ) : (
                                          " Confirm and pay"
                                        )}
                                      </BtnPrimary>
                                    </div>
                                    {/* <div className="flex justify-center mt-6 show-on-mobile">
                                        <Link
                                          to="/login"
                                          className="text-xs text-gray-600 font-semibold hover:text-gray-900 focus:text-gray-600 flex  items-center"
                                        >
                                          Back to log in
                                        </Link>
                                      </div> */}
                                  </form>
                                </div>
                              </div>
                            </Card>
                          </form>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <Dialog
        isOpen={dialogAddOpen}
        onClose={onAddDialogClose}
        onRequestClose={onAddDialogClose}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="49"
              height="49"
              viewBox="0 0 49 49"
              fill="none"
            >
              <rect
                x="0.583008"
                y="1.37207"
                width="47"
                height="47"
                rx="23.5"
                fill="#D1FADF"
              />
              <rect
                x="0.583008"
                y="1.37207"
                width="47"
                height="47"
                rx="23.5"
                stroke="#ECFDF3"
              />
              <path
                d="M32.083 18.8721L21.083 29.8721L16.083 24.8721"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            Thank you for registering. Please log in to continue </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => onAddDialogClose()}>Close</BtnLight>
        </div>
      </Dialog>
    </div>
  );
};

export default RegistrationPaymentYourSelf;
